// extracted by mini-css-extract-plugin
export default {"progress":"progress--msYWR","wave":"wave--e5iux","menu":"menu--oTy6F"};